import { render, staticRenderFns } from "./expireGet.vue?vue&type=template&id=8601144e&scoped=true&"
import script from "./expireGet.vue?vue&type=script&lang=js&"
export * from "./expireGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8601144e",
  null
  
)

export default component.exports